export const VERSION = "18.0.6";
export const RELEASE = "look-in@18.0.6";
